import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './registerSW';

// iOS PWA watchdog (disabled by default). Enable by setting REACT_APP_PWA_BOOT_TIMEOUT_MS>0
(() => {
  try {
    const isStandalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || (navigator as any).standalone === true;
    const configured = process.env.REACT_APP_PWA_BOOT_TIMEOUT_MS;
    if (isStandalone && configured) {
      const timeoutMs = parseInt(configured, 10);
      if (timeoutMs > 0) {
        setTimeout(() => {
          const appReady = (window as any).__APP_READY;
          if (!appReady) {
            const base = (process.env.PUBLIC_URL && process.env.PUBLIC_URL !== '.') ? process.env.PUBLIC_URL : '/';
            try { window.location.assign(base!); } catch { window.location.href = base!; }
          }
        }, timeoutMs);
      }
    }
  } catch {}
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide the splash once React has mounted
(() => {
  const splash = document.getElementById('app-splash');
  if (!splash) return;
  // Give the browser a tick to paint first frame
  requestAnimationFrame(() => {
    splash.style.opacity = '0';
    setTimeout(() => splash.remove(), 250);
  });
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
